<template>
  <div class="ai-container">
    <!-- AI解读整体健康状况 -->
    <div class="ai-interpretation-title">
      <div class="title-with-icon">
        <h2>AI 解读整体健康状况</h2>
        <img
          :src="
            require(`@/assets/AIUnscramble/${
              soundOn === 0
                ? 'replay.png'
                : soundOn === 1
                ? 'pause.png'
                : 'play.png'
            }`)
          "
          class="title-volume-icon"
          :class="{ disabled: !isAudioReady && aiInterpretLoading }"
          alt="音量"
          @click="togglePlayPause"
        />
      </div>
    </div>

    <div class="ai-interpretation-box">
      <div class="ai-interpretation-header">
        <div class="ai-robot">
          <img
            :src="require('@/assets/AIUnscramble/图标-AI小助手2.png')"
            alt="AI机器人"
          />
        </div>
        <div class="interpretation-title">
          <p v-if="aiInterpretLoading || !aiInterpretSummary">
            <span v-if="aiInterpretLoading">正在进行深度分析，请稍等片刻</span>
            <span v-if="!aiInterpretLoading && !aiInterpretSummary"
              >AI正在生成总结中...</span
            >
            <span class="loading-dots">
              <span></span>
              <span></span>
              <span></span>
            </span>
          </p>
          <p v-else v-html="aiInterpretSummary"></p>
        </div>
      </div>
      <div class="interpretation-body" v-if="!isCollapsed">
        <div
          v-if="aiInterpretLoading"
          style="display: none"
          class="loading-container"
        >
          <!-- 已将loading-dots移动到文本后面，这里隐藏原来的容器 -->
        </div>
        <template v-else>
          <p style="white-space: pre-line" v-html="aiInterpretContent"></p>
        </template>
      </div>
    </div>
    <div class="ai-interpretation-tip" v-if="!isCollapsed">
      <div>以上信息基于监测数据模型分析得出，建议及时咨询专业人员进行详细评估与确认。</div>
      <div class="ai-interpretation-tip-paragraph">
        本健康评估报告仅供参考，不作为医疗诊断依据。若需明确疾病诊断，请前往正规医疗机构就诊。
      </div>
    </div>
    
    <!-- 展开/收起按钮 -->
    <div class="collapse-button" @click="toggleCollapse">
      <span>{{ isCollapsed ? "展开更多" : "收起" }}</span>
      <img
        :src="
           require(`@/assets/AIUnscramble/${
             isCollapsed ? 'Down.png' : 'up.png'
           }`)
         "
         class="collapse-arrow-icon"
         alt="展开/收起"
       />
     </div>
    
    <div class="nutrition-data-section">
      <NutritionVitalityCard
          title="营养数据列表"
          :tabsData="nutritionTabsFiltered"
          @item-click="handleNutritionItemClick"
      />
    </div>
    
    <!-- 营养数据列表收起展开按钮 -->
    <div class="collapse-button" @click="toggleNutritionCollapse">
      <span>{{ isNutritionCollapsed ? "展开更多" : "收起" }}</span>
      <img
        :src="
           require(`@/assets/AIUnscramble/${
             isNutritionCollapsed ? 'Down.png' : 'up.png'
           }`)
         "
         class="collapse-arrow-icon"
         alt="展开/收起"
       />
     </div>
    
    <div class="key-results-title">
      <h3>关键监测结果</h3>
      <!-- <div class="key-results-detail" @click="goMicroelement">
        <span class="detail-text">详情</span>
        <img
          class="key-detail"
          alt="详情"
          :src="require('@/assets/进入@2x.png')"
        />
      </div> -->
    </div>

    <div v-if="keyResultsLoading" class="loading-container">
      <div class="loading-dots">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>

    <template v-else-if="keyResultsData && keyResultsData.length > 0">
      <!-- 重要提示 -->
      <div class="note-content">
        <div class="note-title">
          <img
            class="note-icon"
            :src="getIconByLevel('warning')"
            alt="提示"
          />
          <div class="title-text">重要提示：多项营养缺乏</div>
        </div>
        <div class="note-tip">
          发现多项营养素严重缺乏，可能会引起一系列不良反应
        </div>
      </div>
      <!-- 显示获取到的关键监测结果 -->
      <div
        v-for="(result, index) in keyResultsData"
        :key="index"
        class="nutrient-deficiency-card"
      >
        <div class="nutrient-top">
          <div class="deficiency-icon">
            <img :src="getIconByLevel(result.level)" :alt="result.level" />
          </div>
          <div class="deficiency-content">
            <div class="deficiency-title">
              {{ result.title }}，缺乏会导致：
            </div>
            <div class="deficiency-impact" v-if="result.impact">
              {{ result.impact }}
            </div>
          </div>
        </div>

        <div class="deficiency-from">*出自：{{ result.from }}</div>
      </div>
    </template>

    <template v-else>
      <!-- 空状态 -->
      <div class="empty-state">暂无关键监测结果数据</div>
    </template>

    <div class="affected-organs-title">
      <h3>可能受影响的身体系统</h3>
      <div class="key-results-detail" @click="$emit('goOverview')">
        <span class="detail-text">详情</span>
        <img
          class="key-detail"
          :src="require('@/assets/进入@2x.png')"
          alt="详情"
        />
      </div>
    </div>

    <!-- 加载状态 -->
    <div v-if="keyResultsLoading" class="loading-container">
      <div class="loading-dots">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>

    <!-- 有数据时显示器官卡片列表 -->
    <template v-else>
      <div
        class="organ-card"
        v-for="(organ, index) in affectedOrgans"
        :key="organ.system_code + '-' + index"
        @click="handleItemClick(organ)"
      >
        <div class="organ-header">
          <div class="organ-icon">
            <img
              :src="getOrganIcon(organ.name)"
              :alt="organ.name + '图标'"
            />
          </div>
          <div class="organ-content">
            <div class="organ-title">{{ organ.name }}</div>
          </div>
          <div class="organ-arrow">›</div>
        </div>
        <div class="organ-desc">{{ organ.desc }}</div>
      </div>
    </template>

    <slot></slot>
  </div>
</template>

<script>
import { getReportStream } from "@/net/api";
import { getReportKeywordData } from "@/net/api";
import { AudioStreamPlayer } from "@/utils/AudioBlob.js";
import { formatMarkdown } from "@/utils/Helper";
import NutritionVitalityCard from "@/components/NutritionVitalityCard";

export default {
  name: "AIInterpret",
  components: {
    NutritionVitalityCard
  },
  data() {
    return {
      // AI解读音量控制
      soundOn: 2,

      // AI解读整体健康状况数据
      aiInterpretLoading: true,
      aiInterpretSummary: "",
      aiInterpretContent: "", // 文本输出
      // 控制内容是否收起，默认收起
      isCollapsed: true,
      // 控制营养数据列表是否收起，默认收起
      isNutritionCollapsed: true,
      // 关键监测结果数据
      keyResultsData: [],
      keyResultsLoading: true,
      // 音频播放器实例
      audioPlayer: null,
      audioStatus: "未开始",
      eventSource: null,
      isCollecting: true,
      // 存储音频数据，不自动播放
      audioDataBuffer: [],
      isAudioReady: false,
      isUserPlaying: false, // 用户是否主动开始播放
      playedAudioIndex: 0, // 跟踪已播放的音频片段索引
    };
  },
  props: {
    // 编号
    packageNo: {
      type: String,
      default: "",
    },
    rand: {
      type: String,
      default: "",
    },
    checkcode: {
      type: String,
      default: "",
    },
    // 营养素数据
    nutritionTabs: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    "$store.getters.GetOpenAiChat": {
      handler(newVal) {
        if (newVal) {
          this.leavePage();
        }
      },
      immediate: true, // 可选：是否在初始化时立即执行一次
    },
  },
  computed: {
    // 过滤后的营养数据，收起时只显示一半
    nutritionTabsFiltered() {
      if (!this.nutritionTabs || this.nutritionTabs.length === 0) {
        return [];
      }
      
      return this.nutritionTabs.map(tab => {
        if (this.isNutritionCollapsed && tab.items && tab.items.length > 0) {
          return {
            ...tab,
            items: tab.items.slice(0, 11)
          };
        }
        return tab;
      });
    }
  },
  methods: {
    // 打开监测结果详情
    goMicroelement() {
      this.$emit("goMicroelement");
    },
    // 处理营养素项目点击
    handleNutritionItemClick(item) {
      this.$emit('nutrition-item-click', item);
    },
    // 获取关键监测结果数据
    fetchKeywordData() {
      this.keyResultsLoading = true;
      // 使用当前报告的serial_number作为参数
      const serialNumber = this.packageNo;
      console.log("开始获取关键监测结果数据，参数:", {
        serial_number: serialNumber,
      });

      // 重置数据，避免显示旧数据
      this.keyResultsData = [];
      this.affectedOrgans = [];

      getReportKeywordData({ serial_number: this.packageNo })
        .then((data) => {
          console.log("获取关键监测结果数据成功:", data);

          // 处理关键监测结果数据 (hint)
          if (data && data.hint && data.hint.length > 0) {
            // 转换API返回的hint数据为我们需要的关键监测结果格式
            this.keyResultsData = data.hint.map((item) => {
              // 根据value值判断警告级别
              const value = parseFloat(item.value);

              return {
                title: `${item.name} ${item.lack_degree}`,
                description: `当前水平仅为: ${item.value}（正常值: ${item.range[0]}~${item.range[1]}）`,
                impact: item.influence,
                from: item.from,
                level: value < -1.5 ? 'danger':'notice',
                code: item.system_code,
                name: item.name,
              };
            });
          }

          // 处理可能受影响的身体体质数据 (organs_hint)
          if (data && data.organs_hint && data.organs_hint.length > 0) {
            console.log("处理身体体质数据，数量:", data.organs_hint.length);

            // 确保每个对象都有唯一标识和必要的属性
            this.affectedOrgans = data.organs_hint.map((organ, index) => {
              return {
                name: organ.name || "未知体质",
                value: organ.value || "",
                desc: organ.influence || "",
                code: organ.system_code || `unknown-${index}`,
                system_code: organ.system_code || `unknown-${index}`, // 添加system_code字段用作唯一key
                nutrientName: organ.nutrients_name || "",
                index: index, // 添加索引作为备用唯一标识
              };
            });

            console.log("处理后的身体体质数据:", this.affectedOrgans);
          } else {
            console.log("未获取到可能受影响的身体体质数据");
          }

          this.keyResultsLoading = false;
        })
        .catch((err) => {
          console.error("获取关键监测结果数据出错:", err);
          this.keyResultsLoading = false;
        });
    },
    // 根据结果级别获取对应的图标
    getIconByLevel(level) {
      const iconMap = {
        warning: require("@/assets/AIUnscramble/Tips-one (提示)@2x.png"),
        danger: require("@/assets/AIUnscramble/Alarm (警报)@2x.png"),
        notice: require("@/assets/AIUnscramble/Attention (注意)@2x.png"),
      };

      return iconMap[level] || iconMap.notice;
    },
    // 收起/展开功能
    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed;
    },
    // 营养数据列表收起/展开功能
    toggleNutritionCollapse() {
      this.isNutritionCollapsed = !this.isNutritionCollapsed;
    },
    // 获取器官对应的图标
    getOrganIcon(organName) {
      // 器官名称与图标映射关系
      const organIconMap = {
        过劳状态: "/assets/bodyImg/A003.png",
        免疫力: "/assets/bodyImg/A004.png",
        过敏倾向: "/assets/bodyImg/A005.png",
        呼吸系统: "/assets/bodyImg/A006.png",
        心脑供血: "/assets/bodyImg/A007.png",
        血液循环: "/assets/bodyImg/A008.png",
        脾功能: "/assets/bodyImg/A009.png",
        胃肠功能: "/assets/bodyImg/A010.png",
        益生菌: "/assets/bodyImg/A011.png",
        肝胆功能: "/assets/bodyImg/A012.png",
        代谢能力: "/assets/bodyImg/A013.png",
        神经系统: "/assets/bodyImg/A014.png",
        骨骼肌肉: "/assets/bodyImg/A015.png",
        内分泌: "/assets/bodyImg/A016.png",
        肾功能: "/assets/bodyImg/A017.png",
        泌尿生殖: "/assets/bodyImg/A018.png",
      };

      // 返回对应图标，如果没找到则返回默认图标
      return organIconMap[organName] || "/assets/bodyImg/A003.png";
    },
    // 离开页面，暂停音频
    leavePage() {
      if (this.audioPlayer && this.soundOn === 1) {
        this.audioPlayer.pause();
        this.soundOn = 2; // 切换到播放图标
        this.isUserPlaying = false;
        this.$store.commit("SetOpenInterpret", { openInterpret: false });
      }
    },
    // 可能受影响的身体体质跳转到详情页
    handleItemClick(item) {
      this.$router.push({
        path: "/details",
        query: {
          av: item.value || "",
          code: item.system_code || "",
          title: item.name || "",
          color: item.color || "",
          packageNo: this.packageNo,
          rand: this.rand,
          checkcode: this.checkcode,
        },
      });
    },

    // 切换播放/暂停状态
    async togglePlayPause() {
      // 如果音频还没准备好，提示用户等待
      if (!this.isAudioReady && this.aiInterpretLoading) {
        console.warn("音频数据还在加载中，请稍等");
        return;
      }

      // 如果没有音频播放器，初始化并开始播放
      if (!this.audioPlayer) {
        this.$store.commit("SetOpenInterpret", { openInterpret: true });
        this.initAudioPlayer();
        // 确保音频播放器初始化完成后再开始播放
        await this.$nextTick();
        this.startAudioPlayback();
        this.soundOn = 1; // 切换到暂停图标
        return;
      }

      // 如果是重播状态，重新开始播放
      if (this.soundOn === 0) {
        // 重置播放索引，重新播放所有音频
        this.playedAudioIndex = 0;
        this.isUserPlaying = true;

        // 如果播放器有音频数据，直接重播
        if (this.audioPlayer.hasAudioData()) {
          console.log("重播上次的音频");
          this.audioPlayer.replay();
        } else {
          // 重新播放缓存的音频数据
          this.playBufferedAudio();
        }

        this.soundOn = 1; // 切换到暂停图标
        this.$store.commit("SetOpenInterpret", { openInterpret: true });
        return;
      }

      // 获取当前播放状态
      const status = this.audioPlayer.getStatus();

      // 如果当前是播放状态，暂停播放
      if (status.isPlaying && !status.isPaused) {
        this.audioPlayer.pause();
        this.soundOn = 2; // 切换到播放图标
        this.isUserPlaying = false;
        this.$store.commit("SetOpenInterpret", { openInterpret: false });
      }
      // 如果当前是暂停状态，恢复播放
      else if (status.isPaused) {
        this.audioPlayer.resume();
        this.soundOn = 1; // 切换到暂停图标
        this.isUserPlaying = true;
        this.$store.commit("SetOpenInterpret", { openInterpret: true });
      }
      // 如果没有播放，开始播放
      else {
        this.startAudioPlayback();
        this.soundOn = 1; // 切换到暂停图标
        this.$store.commit("SetOpenInterpret", { openInterpret: true });
      }
    },

    initAudioPlayer() {
      // 如果已有播放器，先停止它
      if (this.audioPlayer) {
        this.audioPlayer.stop();
      }

      this.audioPlayer = new AudioStreamPlayer({
        sampleRate: 16000,
        channels: 1,
        volume: 1,
        playbackRate: 1.0,
        fadeDuration: 50,
        filterFrequency: 8000,
        smallChunkThreshold: 5000,
        onStatusUpdate: (status) => {
          this.audioStatus = status;
          // 根据播放状态更新图标
          if (status === "播放完成") {
            this.soundOn = 0; // 切换到重播图标
            this.$store.commit("SetOpenInterpret", { openInterpret: false });
          } else if (status === "已暂停") {
            this.soundOn = 2; // 切换到播放图标
            this.$store.commit("SetOpenInterpret", { openInterpret: false });
          } else if (status === "正在播放") {
            this.soundOn = 1; // 切换到暂停图标
            this.$store.commit("SetOpenInterpret", { openInterpret: true });
          }
        },
        onPlaybackComplete: () => {
          // 播放完成回调
          this.soundOn = 0; // 切换到重播图标
          this.isUserPlaying = false;
          this.$store.commit("SetOpenInterpret", { openInterpret: false });
        },
      });

      return this.audioPlayer;
    },

    // 开始播放缓存的音频数据
    startAudioPlayback() {
      if (!this.audioPlayer) {
        this.initAudioPlayer();
      }

      this.isUserPlaying = true;

      // 播放所有缓存的音频数据
      this.playBufferedAudio();
    },

    // 播放缓存的音频数据
    playBufferedAudio() {
      if (!this.audioPlayer || !this.isUserPlaying) {
        return;
      }

      // 从未播放的音频片段开始播放
      if (this.audioDataBuffer.length > this.playedAudioIndex) {
        const unplayedAudio = this.audioDataBuffer.slice(this.playedAudioIndex);

        // 批量添加音频到播放队列，让播放器内部管理播放顺序
        unplayedAudio.forEach((audioData) => {
          if (this.audioPlayer && this.isUserPlaying) {
            this.audioPlayer.playBase64Audio(audioData);
          }
        });

        // 更新已播放索引
        this.playedAudioIndex = this.audioDataBuffer.length;
      }
    },

    async startInterpretation() {
      // 先停止之前的流数据收集
      this.stopInterpretation();

      // 重置所有状态
      this.aiInterpretContent = "";
      this.aiInterpretSummary = "";
      this.aiInterpretLoading = true;
      this.isCollecting = true;

      // 重置音频相关状态
      this.resetAudioPlayback();
      this.audioDataBuffer = []; // 清空音频缓存
      this.isAudioReady = false;

      if (this.eventSource) {
        this.eventSource.close();
      }

      try {
        const response = await getReportStream({
          serial_number: this.packageNo,
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        if (!response.body) {
          throw new Error("ReadableStream not supported in this browser.");
        }

        this.aiInterpretLoading = false;

        this.streamReader = response.body.getReader();
        const decoder = new TextDecoder();
        let partialData = "";
        let tokenData = "";
        while (this.isCollecting) {
          try {
            const { done, value } = await this.streamReader.read();

            if (done) {
              console.log("流数据读取完成");
              break;
            }

            const textData = decoder.decode(value, { stream: true });
            const dataChunks = (partialData + textData).split("\n");
            partialData = dataChunks.pop() || "";

            for (const chunk of dataChunks) {
              if (!chunk.trim()) continue;

              try {
                // 处理 Server-Sent Events 格式的数据
                let jsonString = chunk;

                // 如果是 SSE 格式，提取 data: 后面的内容
                if (chunk.startsWith("data: ")) {
                  jsonString = chunk.substring(6); // 移除 "data: " 前缀
                }

                // 跳过空数据或注释行
                if (!jsonString.trim() || jsonString.startsWith(":")) {
                  continue;
                }

                const jsonData = JSON.parse(jsonString);
                const { token, summarize, audio, token_finish } = jsonData;

                if (token) {
                  tokenData += token;
                  this.aiInterpretContent = formatMarkdown(tokenData);
                }

                if (summarize) {
                  this.aiInterpretSummary += summarize;
                }
                if (token_finish) {
                  this.$emit("suggestionHandle");
                  this.$store.commit("SetAiChatEnabled", {
                    aiChatEnabled: true,
                  });
                }

                if (audio) {
                  // 将音频数据存储到缓存中
                  this.audioDataBuffer.push(audio);
                  this.isAudioReady = true;
                  // 如果用户已经开始播放，则播放新接收到的音频数据
                  if (this.isUserPlaying && this.audioPlayer) {
                    // 只播放新接收到的音频片段
                    this.audioPlayer.playBase64Audio(audio);
                    this.playedAudioIndex = this.audioDataBuffer.length;
                  }
                }
              } catch (e) {
                console.error("解析数据失败:", e, "原始数据:", chunk);
                // 不要在这里设置 isCollecting = false，继续处理其他数据
              }
            }
          } catch (readError) {
            console.error("读取流数据失败:", readError);
            break;
          }
        }

        // 处理剩余的部分数据
        if (partialData.trim()) {
          try {
            let jsonString = partialData;
            if (partialData.startsWith("data: ")) {
              jsonString = partialData.substring(6);
            }

            if (jsonString.trim() && !jsonString.startsWith(":")) {
              const jsonData = JSON.parse(jsonString);
              const { token, summarize, audio, token_finish } = jsonData;

              if (token) {
                tokenData += token;
                this.aiInterpretContent = formatMarkdown(tokenData);
              }
              if (summarize) this.aiInterpretSummary += summarize;
              if (token_finish) {
                this.$emit("suggestionHandle");
                this.$store.commit("SetAiChatEnabled", {
                  aiChatEnabled: true,
                });
              }
              if (audio) {
                // 将音频数据存储到缓存中
                this.audioDataBuffer.push(audio);
                this.isAudioReady = true;

                // 如果用户已经开始播放，则播放新接收到的音频数据
                if (this.isUserPlaying && this.audioPlayer) {
                  this.audioPlayer.playBase64Audio(audio);
                  this.playedAudioIndex = this.audioDataBuffer.length;
                }
              }
            }
          } catch (e) {
            console.error("处理剩余数据失败:", e);
          }
        }

        // AI 解读完成，更新全局状态，允许使用聊天功能
        // this.$store.commit("SET_AI_INTERPRET_COMPLETED", {
        //   completed: true,
        //   packageNo: this.packageNo,
        // });
        console.log("AI 解读完成，聊天功能已启用");
      } catch (error) {
        console.error("启动解读失败:", error);
        this.aiInterpretLoading = false;
        // 解读失败时也不允许使用聊天
        // this.$store.commit("SET_AI_INTERPRET_COMPLETED", {
        //   completed: false,
        //   packageNo: this.packageNo,
        // });
      } finally {
        this.isCollecting = false;
      }
    },

    // 停止流数据收集
    stopInterpretation() {
      this.isCollecting = false;
      if (this.streamReader) {
        try {
          this.streamReader.cancel();
        } catch (err) {
          console.warn("取消流读取器失败:", err);
        }
        this.streamReader = null;
      }
    },
    // 暂停音频
    stopPlay() {
      console.log("ai解读外");
      if (this.audioPlayer) {
        console.log("ai解读内");
        this.audioPlayer.pause();
        this.soundOn = 2; // 切换到播放图标
        this.isUserPlaying = false;
        this.$store.commit("SetOpenInterpret", { openInterpret: false });
      }
    },

    // 检查是否有音频数据可以播放
    hasAudioData() {
      return (
        this.audioDataBuffer.length > 0 ||
        (this.audioPlayer && this.audioPlayer.hasAudioData())
      );
    },

    // 重置音频播放状态
    resetAudioPlayback() {
      this.playedAudioIndex = 0;
      this.isUserPlaying = false;
      this.soundOn = 2;
      if (this.audioPlayer) {
        this.audioPlayer.stop();
      }
    },
  },

  mounted() {
    this.startInterpretation();
    this.fetchKeywordData();
  },
  deactivated() {
    this.leavePage();
  },

  beforeUnmount() {
    // 停止流数据收集
    this.stopInterpretation();

    // 清理音频播放器资源
    if (this.audioPlayer) {
      this.audioPlayer.stop();
      this.audioPlayer = null;
    }
    if (this.eventSource) {
      this.eventSource.close();
    }

    // 清理音频缓存
    this.audioDataBuffer = [];
    this.isAudioReady = false;
    this.isUserPlaying = false;
    this.playedAudioIndex = 0;
  },
};
</script>

<style lang="scss" scoped>
.ai-container {
  padding: 0 26px;
  //  background-color: pink;
}
/* AI解读整体健康状况 */
.ai-interpretation-title {
  display: flex;
  padding: 20px 15px 15px;
}

.title-with-icon {
  display: flex;
  align-items: center;
}

.ai-interpretation-title h2 {
  font-size: 32px;
  font-weight: 600;
  color: #2c324e;
  margin: 0;
  margin-right: 10px;
}

.title-volume-icon {
  width: 38px;
  height: 38px;
  margin-left: 20px;
  // cursor: pointer;
  transition: opacity 0.3s ease;
}

.title-volume-icon.disabled {
  opacity: 0.5;
  // cursor: not-allowed;
}

.ai-interpretation-box {
  // background: #FFFFFF;
  border-radius: 20px;
  border: 2px solid #cecece;
  margin: 0 15px 20px;
  padding: 20px;
}
.ai-interpretation-tip {
  color: #b3b3b3;
  font-size: 20px;
  padding: 0 20px;
  margin-bottom: 50px;
}

.ai-interpretation-tip-paragraph {
  margin-top: 8px;
}

.nutrition-data-section {
  margin-top: 40px;
}

.ai-interpretation-header {
  display: flex;
  align-items: center;
  margin-top: 25px;
  margin-bottom: 20px;
  padding-left: 20px;
}

.ai-robot {
  margin-right: 15px;
}

.ai-robot img {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  object-fit: contain;
}

.interpretation-title {
  flex: 1;
  padding-left: 20px;
}

.interpretation-title p {
  font-size: 24px;
  font-weight: 500;
  color: #808080;
  margin: 0;
  line-height: 1.4;
}

.interpretation-body {
  padding-top: 10px;
}

.interpretation-body p {
  font-size: 26px;
  line-height: 1.6;
  color: #495880;
  margin-bottom: 15px;
  font-weight: 500;
}

.interpretation-body p:last-child {
  margin-bottom: 0;
}

.key-results-title,
.affected-functions-title {
  padding: 60px 15px 10px;
  font-size: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.key-results-title h3,
.affected-functions-title h3 {
  font-size: 32px;
  font-weight: 600;
  color: #333;
  margin: 0;
}
.key-results-detail {
  font-size: 23px;
  color: #495880;
  .detail-text {
    vertical-align: super;
  }
  .key-detail {
    width: 38px;
    height: 38px;
  }
}
// 重要提示
.note-content {
  width: 90%;
  background-color: #f0f0f0;
  font-size: 28px;
  padding: 30px;
  border-radius: 20px;
  margin: 20px auto;
  // display: flex;
  .note-icon {
    width: 30px;
    height: 30px;
    margin-right: 20px;
  }
  .note-title {
    display: flex;
    align-items: center;
    font-weight: bold;
  }
  .note-tip {
    font-size: 22px;
    color: #495880;
    margin-left: 50px;
    padding-top: 10px;
  }
}

/* 营养素缺乏卡片样式 - 根据用户提供的图片样式 */
.nutrient-deficiency-card {
  width: 100%;
  //margin: 20px auto;
  margin: 20px 0;

  background: #fefaf9;
  border: 2px solid #ffdede;
  border-radius: 20px;
  padding: 20px;
  // box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
}
.nutrient-top {
  display: flex;
  align-items: flex-start;
}
.deficiency-icon {
  margin-right: 15px;
  flex-shrink: 0;
}

.deficiency-icon img {
  width: 32px;
  height: 32px;
}

.deficiency-content {
  flex: 1;
}

.deficiency-title {
  font-size: 28px;
  font-weight: 600;
  margin-bottom: 15px;
  color: #2c324e;
}

.deficiency-level {
  font-size: 26px;
  color: #495880;
  margin-bottom: 12px;
}

.deficiency-impact {
  font-size: 26px;
  color: #495880;
  line-height: 1.5;
  white-space: pre-line;
  word-break: break-all;
}
.deficiency-from {
  box-sizing: border-box;
  color: #b3b3b3;
  font-size: 20px;
  //padding: 20px 0;
  padding-top: 10px;
  margin-top: 10px;
  border-top: 1px solid #f0f0f0;
  white-space: nowrap; /* 禁止换行 */
  overflow: hidden; /* 隐藏超出内容 */
  text-overflow: ellipsis; /* 超出部分显示省略号 */
  width: 100%; /* 需要设置一个宽度限制 */
  display: block; /* 对于非块级元素需要设置为块级或inline-block */
}

/* 保留原有样式用于其他部分 */
.result-card {
  display: flex;
  align-items: flex-start;
  background: #ffffff;
  border-radius: 12px;
  margin: 0 15px 30px;
  padding: 18px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
}

.warning-card {
  background-color: #ececec;
}

.affected-functions {
  padding: 20px;
}

.affected-functions h3 {
  font-size: 30px;
  font-weight: 600;
  color: #333;
  margin: 0 0 15px;
}

.function-item {
  display: flex;
  padding: 15px 0;
  border-bottom: 1px solid #eaedf2;
  align-items: center;
}

.function-icon {
  width: 60px;
  height: 60px;
  margin-right: 15px;
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.function-icon img {
  width: 40px;
  height: 40px;
  object-fit: contain;
}

.function-text-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  font-size: 22px;
  font-weight: 500;
  color: #003cbf;
  background-color: #e9f0ff;
  border-radius: 50%;
}

.function-details {
  flex: 1;
}

.function-title {
  font-size: 28px;
  font-weight: 600;
  color: #333;
  margin-bottom: 5px;
}

.function-desc {
  font-size: 24px;
  color: #666;
}

.function-arrow {
  font-size: 30px;
  color: #999;
  margin-left: 10px;
}

/* 可能受影响的器官功能 */
.affected-organs-title {
  padding: 70px 15px 10px;
  display: flex;
  justify-content: space-between;
}

.affected-organs-title h3 {
  font-size: 32px;
  font-weight: 600;
  color: #333;
  margin: 0;
}

.organ-card {
  display: flex;
  flex-direction: column;
  background: #fefaf9;
  border-radius: 16px;
  margin: 20px 0;
  padding: 20px;
  transition: all 0.2s ease;
  border: 2px solid #ffdede;
}

.organ-card:hover {
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.organ-header {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: flex-start;
  margin-bottom: 8px;
}

.organ-content {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.organ-icon {
  width: 60px;
  height: 60px;
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.organ-icon img {
  width: 45px;
  height: 45px;
  object-fit: contain;
}

.organ-title {
  font-size: 28px;
  font-weight: 500;
  color: #2c324e;
  flex: 1;
}

.organ-nutrient {
  font-size: 24px;
  color: #6c7ab4;
  margin-top: 4px;
  margin-bottom: 6px;
}

.organ-desc {
  font-size: 24px;
  color: #495880;
  line-height: 1.4;
  // padding-left: 0;
  margin-top: 5px;
  margin-left: 10px;
}

.organ-arrow {
  font-size: 46px;
  color: #999;
  margin-right: 30px;
  flex-shrink: 0;
}

.collapse-button {
  text-align: center;
  padding: 15px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  // cursor: pointer;
  margin: 5px 0;
  font-size: 28px;
}

.collapse-arrow-icon {
  width: 40px;
  height: 40px;
  margin-left: 10px;
  transition: transform 0.3s;
}

.collapse-icon.is-expanded {
  transform: rotate(0deg);
}

.chat-button-container {
  padding: 20px 15px 25px;
}

.ai-chat-button {
  width: 100%;
  height: 90px;
  background-color: #003cbf;
  color: #ffffff;
  border: none;
  border-radius: 45px;
  padding: 10px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  // cursor: pointer;
}
/* 空状态样式 */
.empty-state {
  text-align: center;
  padding: 40px 0;
  color: #999;
  font-size: 28px;
}

.primary-text {
  font-size: 28px;
  font-weight: 500;
  margin-bottom: 5px;
}

.secondary-text {
  font-size: 22px;
  font-weight: 400;
  opacity: 0.9;
}

/* 添加折叠/展开动画 */
.collapse-transition-enter-active,
.collapse-transition-leave-active {
  transition: all 0.3s ease;
  max-height: 1000px; /* 足够大的高度以确保内容完全展示 */
  overflow: hidden;
}

.collapse-transition-enter-from,
.collapse-transition-leave-to {
  max-height: 0;
  opacity: 0;
  margin-top: 0;
  margin-bottom: 0;
  padding-top: 0;
  padding-bottom: 0;
}

/* 加载动画样式 */
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
}

.loading-dots {
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  margin-left: 5px;
}

.loading-dots span {
  display: inline-block;
  width: 10px;
  height: 10px;
  margin: 0 3px;
  background-color: #003cbf;
  border-radius: 50%;
  opacity: 0.6;
  animation: loadingDots 1.4s infinite ease-in-out both;
}

.loading-dots span:nth-child(1) {
  animation-delay: -0.32s;
}

.loading-dots span:nth-child(2) {
  animation-delay: -0.16s;
}

@keyframes loadingDots {
  0%,
  80%,
  100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1);
  }
}

/* 添加流式文字展示的动画效果 */
.typing-animation {
  position: relative;
  border-right: 2px solid transparent;
  animation: typing-cursor 0.8s infinite;
}

@keyframes typing-cursor {
  0%,
  100% {
    border-color: transparent;
  }
  50% {
    border-color: #333;
  }
}
</style>
